<template>
  <v-card elevation="2" class="ml-5 mr-5 mt-5 mb-5">
    <v-data-table
      :headers="headers"
      :items="submissionCategoryItems"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Kategori Submission</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <!-- <template v-if="permission.includes('Create Kategori Submission')" v-slot:activator="{ on }"> -->
            <template v-if="role == 'accountant'" v-slot:activator="{ on }">
              <v-btn
                color="primary"
                small
                dark
                class="mb-2"
                v-on="on"
                @click="[(dialog = true)]"
                >Buat Kategori Submission</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field
                      v-model="editedItem.name"
                      label="Nama Kategori Submission"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-select
                      v-model="editedItem.type"
                      :items="['PEMASUKAN', 'PENGELUARAN']"
                      label="Tipe Submission"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close()"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.no`]="{ item }">
        {{ submissionCategoryItems.indexOf(item) + 1 + "." }}
      </template>
      <template v-slot:no-data>
        <span class="text-center">No data available.</span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <template v-if="role == 'accountant'">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <!-- <v-icon v-on="on" small class="mr-2" v-if="permission.includes('Update Kategori Submission')" @click="editItem(item)">edit</v-icon> -->
              <v-icon
                v-on="on"
                v-if="
                  item.name != 'UNCATEGORIZED' &&
                  item.name != 'ORDER' &&
                  item.name != 'BELANJA'
                "
                small
                class="mr-2"
                @click="editItem(item)"
                >edit</v-icon
              >
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <!-- <v-icon v-on="on" small class="mr-2" v-if="permission.includes('Delete Kategori Submission')" @click="deleteItem(item)">delete</v-icon> -->
              <v-icon
                v-on="on"
                v-if="
                  item.name != 'UNCATEGORIZED' &&
                  item.name != 'ORDER' &&
                  item.name != 'BELANJA'
                "
                small
                class="mr-2"
                @click="deleteItem(item)"
                >delete</v-icon
              >
            </template>
            <span>Hapus</span>
          </v-tooltip>
        </template>
        <template v-else>
          <span>-</span>
        </template>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import itemTemplate from "@/components/ItemTemplate.vue";
export default {
  data: () => ({
    itemTemplate,
    dialog: false,
    expand: false,
    role: "",
    permission: [],
    showError: false,
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no",
      },
      { text: "Kategori Submission", value: "name" },
      { text: "Tipe Submission", value: "type" },
      { text: "Actions", align: "center", value: "action", sortable: false },
    ],
    submissionCategoryItems: [],
    item: "",
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
  }),

  computed: {
    ...mapGetters({}),

    formTitle() {
      return this.editedIndex === -1
        ? "Buat Kategori Submission"
        : "Edit Kategori Submission";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      getSubmissionCategories: "submission_categories/getSubmissionCategories",
      createSubmissionCategories:
        "submission_categories/createSubmissionCategories",
      updateSubmissionCategories:
        "submission_categories/updateSubmissionCategories",
      deleteSubmissionCategories:
        "submission_categories/deleteSubmissionCategories",
    }),
    async initialize() {
      const userLogin = JSON.parse(window.localStorage.getItem("user_data"));
      this.role = userLogin.roles[0].name;
      this.permission = userLogin.permissions;
      const dataItem = await this.getSubmissionCategories();
      // console.log('dataItem', dataItem)

      await forEach(dataItem.data, (data) => {
        this.submissionCategoryItems.push(data);
      });
    },

    editItem(data) {
      this.editedIndex = this.submissionCategoryItems.indexOf(data);
      this.editedItem = Object.assign({}, data);
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.submissionCategoryItems.indexOf(item);
      if (confirm("Apakah anda yakin menghapus kategori submission ini?")) {
        const response = await this.deleteSubmissionCategories(item.id);
        if (response.status == 200) {
          this.submissionCategoryItems.splice(index, 1);
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: `Sukses menghapus kategori submission ${item.name}`,
          });
        }
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      try {
        if (this.editedIndex > -1) {
          const response = await this.updateSubmissionCategories(
            this.editedItem
          );
          if (response.status == 200) {
            Object.assign(
              this.submissionCategoryItems[this.editedIndex],
              response.data.data
            );
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: `Sukses memperbarui kategori submission ${response.data.data.name}`,
            });
          }
        } else {
          const response = await this.createSubmissionCategories(
            this.editedItem
          );
          if (response.status == 200) {
            this.submissionCategoryItems.splice(0, 0, response.data.data);
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: `Sukses membuat kategori submission ${response.data.data.name}`,
            });
          }
        }
        this.close();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style>
.vue-suggestion .vs__input {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid black;
  max-height: 400px;
  overflow-y: auto;
  font-size: 16px;
  color: black;
  position: relative;
}
.vue-suggestion .vs__list {
  width: 100%;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #023d7b;
  position: relative;
}
.vue-suggestion .vs__list .vs__list-item {
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding: 10px;
  border-left: 1px solid #023d7b;
  border-right: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
  cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}
</style>